import { PageViewType } from 'templates/ProductPage/models';

export enum ProductBlockType {
  Left = 'Left',
  Right = 'Right',
}

export type TAnchorWrapperProps = {
  anchor?: string;
};

export interface ILandingPage {
  data: ILandingPageData;
  type: PageViewType;
}

interface ILandingPageData extends PageContent.IDefaultLayoutProps {
  page: ILandingPageContent;
}

interface ILandingPageContent {
  seoNoIndex: boolean;
  seoMetaTitle: string;
  seoMetaDescription: string;
  seoMetaKeywords: string[];
  seoCanonicalUrl?: string;
  seoImage?: string;
  ogPageType?: string;
  seoExternalHreflangs?: [
    {
      key: string;
      value: string;
    }
  ];
  link: string;
  content?: string;
  landingPageBody: TLandingPageBody[];
  metaKeywords: string[];
}

interface IStringValue {
  value: string;
}

interface IIconTextProps {
  description: string;
  iconName: string;
}

interface IIconText {
  properties: IIconTextProps;
  structure: string;
}

type TLandingPageBody = {
  heading: string;
  structure: string;
  instructions: IStringValue[];
  disclaimers: IStringValue[];
  leftFeatures: IIconText[];
  rightFeatures: IIconText[];
  features: IIconText[];
  leftSubHeading: string;
  rightSubHeading: string;
  image: PageContent.TUmbracoImage;
  subHeading: string;
  backgroundImage: PageContent.TUmbracoImage;
  backgroundImageMobile: PageContent.TUmbracoImage;
  productImageDesktop: PageContent.TUmbracoImage;
  productImageMobile: PageContent.TUmbracoImage;
  finePrint: string;
  menuLinks: PageContent.TLink[];
  link: PageContent.TLink[];
  articleSectionDescription: string;
  cssClassName: string;
  productImageDescription: string;
  onTheGoHeading: string;
  onTheGoDescription: string;
  video: string;
  animation: {
    url: string;
    fallbackUrl: string;
  };
  autoPlay: string;
  titleRegular: string;
  titleBold: string;
  descriptionText: string;
  expansionText: string;
  buttonText: string;
  ariaLabel: string;
  buttonLink: TLink;
  backgroundType: string[];
  blockType: string[];
  imageType: string[];
  sectionLandmark: string;
  title: string;
  description: string;
  background: string;
  anchorTitle: string;
  textColor: string;
  items: Array<{
    structure: string;
    properties: {
      featureImage: PageContent.TUmbracoImage;
      featureTitle: string;
      featureDescription: string;
    };
  }>;
};
